import seoPage from '@/data/webInfo/view/seo.vue'
import webPageSEO from '@/data/webInfo/view/webpage-seo.vue'
import shippingCostPage from '@/data/webInfo/view/shipping-cost.vue'
import webPageContentWANEditor from '@/data/webInfo/view/webpage-content-wanwaneditor.vue'

const seo = {
  path: '/seo',
  name: 'seo',
  component: seoPage
}
const seoOfPage = {
  path: '/seo/:page',
  name: 'webpage-seo',
  component: webPageSEO
}
const shippingCost = {
  path: '/settings/shipping-cost',
  name: 'settings-shipping-cost',
  component: shippingCostPage
}
const contentOfPageOfWANEditor = {
  path: '/content-wanwaneditor/:page',
  name: 'webpage-content-wanwaneditor',
  component: webPageContentWANEditor
}

export default [seo, seoOfPage, shippingCost, contentOfPageOfWANEditor]
